import React from 'react'
import ApprovalHybridViewContainer from '../../containers/approvalmng/ApprovalHybridViewContainer'

const ApprovalViewPage = () => {
  return <ApprovalHybridViewContainer/>
}

export default ApprovalViewPage
